<div class="surveys">
  <div class="surveys_header">
    <p class="surveys_header__title">Feedback survey.</p>
    <p-splitButton class="surveys_header__export" #actions label="Download report" styleClass="export-button"
      [model]="actionItems" (onClick)="actions.onDropdownButtonClick(null)">
    </p-splitButton>
  </div>

  <div class="surveys_stats" *ngIf="statisticsList.length">
    <div *ngFor="let stats of statisticsList">
      <p>Account Name: {{ stats.account_ident }}</p>
      <p>Average Rating: {{ stats.Average_rating }}</p>
      <p>Total surveys submitted: {{ stats.Total_ratings }}</p>
      <p>Total positive rating: {{ stats.Total_positive_ratings }}</p>
      <p>Total neutral rating: {{ stats.Total_neutral_ratings }}</p>
      <p>Total negative rating: {{ stats.Total_negative_ratings }}</p>
    </div>
  </div>

  <div class="surveys_list">
    <p-table #dt [value]="feedbackSurveysList" [loading]="isLoadingData" [paginator]="true" [rows]="25" [first]="first"
      [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '50rem' }"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onPage)="pageChange($event)"
      sortMode="multiple" sortOrder="-1" [globalFilterFields]="['updated_at']" (onLazyLoad)="lazyLoadLocations($event)" [lazy]="true"
      [totalRecords]="totalRecords" [lazyLoadOnInit]="true">

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let column of displayColumns">
            <th *ngIf="column.sortField" [pSortableColumn]="column.sortField">
              {{ column.label }}
              <p-sortIcon [field]="column.sortField"></p-sortIcon>
            </th>
            <th *ngIf="!column.sortField">{{ column.label }}</th>
          </ng-container>
          <th class="responses">Responses</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr>
          <td *ngFor="let column of displayColumns" [ngClass]="{ comments: column.key === 'comment' || column.key === 'comments' }">
            {{ getDisplayCellValue(data, column.key) }}
          </td>
          <td class="responses">
            <div class="responses-container">
              <div class="response-field">
                <label>Responded to:</label>
                <p-checkbox [binary]="true" [(ngModel)]="data.responded_to" [disabled]="true"></p-checkbox>
              </div>
              <div class="response-field">
                <label>Internal user Comment:</label>
                <span>{{ data?.internal_user_comment || "N/A" }}</span>
              </div>
              <div class="response-field">
                <label>Responded by:</label>
                <span>{{ data?.responded_by || "N/A" }}</span>
              </div>
              <div class="response-actions">
                <button type="button" pButton label="Edit" icon="pi pi-pencil" class="p-button-sm p-button-text" (click)="openEditDialog(data)"></button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Edit Response Dialog -->
<p-dialog [(visible)]="showEditDialog" [modal]="true" [style]="{width: '500px'}" [closable]="true" (onHide)="closeEditDialog()">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">Edit Response</span>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="edit-response-form">
      <div class="form-field">
        <label for="respondedTo">Responded to:</label>
        <p-checkbox id="respondedTo" [binary]="true" [(ngModel)]="editRespondedTo" inputId="respondedTo"></p-checkbox>
      </div>
      <div class="form-field">
        <label for="internalComment">Internal user Comment:</label>
        <textarea id="internalComment" pInputTextarea [(ngModel)]="editInternalComment" [rows]="4" placeholder="Enter internal comment"></textarea>
      </div>
      <div class="form-field">
        <label>Responded by:</label>
        <span>{{ getRespondedByDisplayText() }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="closeEditDialog()" [disabled]="isSavingResponse"></button>
    <button type="button" pButton label="Save" icon="pi pi-check" (click)="saveResponseFields()" [loading]="isSavingResponse" [disabled]="isSavingResponse"></button>
  </ng-template>
</p-dialog>
